<p-floatlabel variant="on">
  <textarea
    #textareaRef
    (input)="inputEvent.emit($event)"
    (keydown)="keydownEvent.emit($event)"
    [formControl]="this.control()"
    class="h-full" cols="30" fluid id="on_label" pTextarea rows="{{this.rows()}}"
    style="resize: none"
    [placeholder]="this.placeholder()"
  ></textarea>
  @if (this.label()) {

    <label for="on_label">{{ this.label() }}</label>
  }
</p-floatlabel>
